import React from 'react';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import useStyles from './style';

/**
 * SortableHeader component for table column headers with sorting functionality
 * @param {Object} column - The column object from react-table
 * @param {Function} onSortChange - Function to handle sort changes
 * @param {Object} sortBy - Current sort state: { id: 'columnId', desc: boolean }
 * @param {boolean} isSortable - Whether the column is sortable
 */
const SortableHeader = ({ column, onSortChange, sortBy, isSortable }) => {
  const classes = useStyles();

  // If column is not sortable, just render the header content
  if (!isSortable) {
    return column.render('Header');
  }

  const isCurrentlySorted = sortBy && sortBy.id === column.id;
  const isDesc = isCurrentlySorted ? sortBy.desc : false;

  return (
    <button
      type="button"
      className={classes.sortButton}
      onClick={() => {
        onSortChange(column.id, !isDesc);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSortChange(column.id, !isDesc);
        }
      }}
      aria-label={`Sort by ${column.Header} ${isDesc ? 'ascending' : 'descending'}`}
    >
      <span>{column.render('Header')}</span>
      <span
        className={classes.sortIcon}
        style={{
          visibility: isCurrentlySorted ? 'visible' : 'hidden',
        }}
      >
        {isDesc ? <ArrowDownward fontSize="small" /> : <ArrowUpward fontSize="small" />}
      </span>
    </button>
  );
};

export default SortableHeader;
